// @ts-ignore
import { usePage, EditableToken } from '@vibesites/runtime/react';
import type { ComponentContentSchema } from '@vibesites/runtime';
import { CorporateHeader } from './CorporateHeader';
import { PropertyPageHeader } from './PropertyPageHeader';

/**
 * Smart header that renders PropertyPageHeader on property template pages,
 * and CorporateHeader on all other pages.
 */
export function SmartHeader() {
  const page = usePage();
  // Match via resolved alias ("property-home"), template field, or raw path pattern
  const alias = page?.alias || '';
  const isPropertyPage = alias.startsWith('property-')
    || page?.template === 'property'
    || /^apartments\/[^/]+\/[^/]+\/[^/]+/.test(alias);
  return (
    <EditableToken path="header.company_logo" type="image" label="Company Logo" as="div" style={{ display: 'contents' }} defaultField={contentSchema.tokens['header.company_logo'].defaultField} defaultValue={contentSchema.tokens['header.company_logo'].defaultValue}>
      <EditableToken path="header.company_logo_alt" type="text" label="Company Logo Alt Text" as="div" style={{ display: 'contents' }} defaultField={contentSchema.tokens['header.company_logo_alt'].defaultField} defaultValue={contentSchema.tokens['header.company_logo_alt'].defaultValue}>
        <EditableToken path="header.phone" type="phone" label="Phone Number" as="div" style={{ display: 'contents' }} defaultField={contentSchema.tokens['header.phone'].defaultField} defaultValue={contentSchema.tokens['header.phone'].defaultValue}>
          <EditableToken path="header.cta_text" type="text" label="CTA Button Text" as="div" style={{ display: 'contents' }} defaultValue={contentSchema.tokens['header.cta_text'].defaultValue}>
            <EditableToken path="header.cta_url" type="url" label="CTA URL" as="div" style={{ display: 'contents' }} defaultValue={contentSchema.tokens['header.cta_url'].defaultValue}>
              {isPropertyPage ? <PropertyPageHeader /> : <CorporateHeader />}
            </EditableToken>
          </EditableToken>
        </EditableToken>
      </EditableToken>
    </EditableToken>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'Header',
  displayName: 'Header',
  tokens: {
    'header.company_logo': {
      label: 'Company Logo',
      type: 'image',
      defaultField: 'property_company_logo',
      suggestedFields: ['property_company_logo', 'property_company_mono_black_logo', 'property_company_mono_white_logo'],
      defaultValue: 'https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019d6a03-1ba6-7434-907e-8af645744a5a.webp',
    },
    'header.company_logo_alt': {
      label: 'Company Logo Alt Text',
      type: 'text',
      defaultField: 'property_company_name',
      defaultValue: 'Case and Associates logo',
    },
    'header.phone': {
      label: 'Phone Number',
      type: 'phone',
      defaultField: 'property_phone',
      defaultValue: '(918) 492-1983',
    },
    'header.cta_text': {
      label: 'CTA Button Text',
      type: 'text',
      defaultValue: 'Contact Us',
    },
    'header.cta_url': {
      label: 'CTA URL',
      type: 'url',
      defaultValue: '/contact-us/',
    },
  },
};

(SmartHeader as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default SmartHeader;
